import { render } from 'react-dom'

import { AppInitProvider } from './AppInit'
import PlannerContainer from './containers/PlannerContainer'

const app = document.getElementById('appointment-planner')

render(
  <AppInitProvider>
    <PlannerContainer />
  </AppInitProvider>,
  app
)
